export const environment = {
    production: false,
    apiUrl: 'https://qabe.carevance.solutions',
    onboardingUrl: 'https://onboardingapiqa.carevance.solutions',
    commonLookupUrl: 'https://commonapiqa.carevance.solutions',
    twilioUrl: 'https://twilioapiqa.carevance.solutions',
    demoUrl: 'https://demoapiqa.carevance.solutions',
    careManagerPortalUrl: 'https://caremanagerapiqa.carevance.solutions',
    microserviceurl:'https://servicemanagementapiqa.carevance.solutions',
    logisticUrl: 'https://logisticsapiqa.carevance.solutions',
    ragUrl: 'https://rag-chat-api.carevance.solutions',
    demoNew:'https://auto-calls.carevance.solutions',
  doctorUrl: 'https://doctorapiqa.carevance.solutions',

  };